/**
 * 下層KVエリア
 */
export default class commonKV {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'commonKV';
    this.el = document.getElementById('p-hero');
    this.isActive = (this.el) ? true : false;
    this.preventWidth = 0;

    this.init();
  }

  /**
   * 表示前
   */
  init() {
    if (!this.isActive) return;
    TweenMax.set(this.el, {className: '+=is-hide'});
  }

  /**
   * 表示時
   */
  start() {
    if (!this.isActive) return;
    requestAnimationFrame(this.delayStart.bind(this));
  }

  /**
   * ずらして実行
   */
  delayStart() {
    TweenMax.set(this.el, {className: '-=is-hide'});
  }
}
